import * as EnvioHttp from '../../../../services/api/https/deliveries/envio-rota.http'
import React, { useEffect, useState } from 'react'
import { showMessageBox } from '../../../../store/actions/system.actions'
import { errorHandler } from '../../../../services/util/error.service'
import { parseToMysqlFormat } from '../../../../services/util/date.service'
import {
  Btn,
  CustomCalendar,
  CustomCheckbox,
  CustomDropdown,
  CustomDropdownWithFilter,
  CustomModal,
  InputTime,
} from '../../../../components'
import { connect } from 'react-redux'

function ModalEditarElement({
  data: { veiculos, motoristas, ajudantes, frota, motivosAtraso },
  isVisible,
  onClose,
  dispatch,
}) {
  const [selectedMotorista, setSelectedMotorista] = useState('')
  const [selectedVeiculo, setSelectedVeiculo] = useState('')
  const [selectedAjudante, setSelectedAjudante] = useState(null)
  const [isBtnLoading, setIsBtnLoading] = useState(false)
  const [horarioSaida, setHorarioSaida] = useState('')
  const [isLated, setIsLated] = useState(false)
  const [motivoAtraso, setMotivoAtraso] = useState(null)
  const [dataPrevista, setDataPrevista] = useState(null)
  //Events
  const btnSalvarClicked = async () => {
    try {
      if (isLated && !motivoAtraso) throw Error('Selecione um motivo de atraso')
      setIsBtnLoading(true)
      const fetchedFrota = await EnvioHttp.alterarVeiculoMotorista(frota.fleet_id, {
        vehicle_id: selectedVeiculo.id,
        driver_id: selectedMotorista.id,
        driver_assistant_id: selectedAjudante && selectedAjudante.id ? selectedAjudante.id : null,
        departure_time: horarioSaida.length && horarioSaida !== '__:__' ? horarioSaida : null,
        vehicle_lated: isLated,
        motivo_atraso_id: motivoAtraso && isLated ? motivoAtraso.id : null,
        expected_date: parseToMysqlFormat(dataPrevista),
      })
      dispatch(showMessageBox('Frota atualizada com sucesso', null))
      onClose(fetchedFrota)
    } catch (error) {
      setIsBtnLoading(false)
      dispatch(showMessageBox(null, errorHandler(error)))
    }
  }

  // Hooks
  useEffect(() => {
    setSelectedMotorista(_getSelectedMotorista())
    setSelectedVeiculo(_getSelectedVeiculo())
    setSelectedAjudante(_getSelectedAjudante())
    setHorarioSaida(_getHorarioSaida())
    setIsLated(_getIsLated())
    setMotivoAtraso(_getMotivoAtraso())
    setDataPrevista(_getDataPrevista())
    setIsBtnLoading(false)
  }, [frota, ajudantes, motoristas, veiculos, motivosAtraso])
  // Helpers
  const _getDataPrevista = () => {
    if (!frota.expected_date) return new Date()
    const datePart = frota.expected_date.substring(0, 10)
    const [year, month, day] = datePart.split('-')
    return new Date(Number(year), Number(month) - 1, Number(day))
  }
  const _getSelectedMotorista = () => {
    const motorista = motoristas.find(m => m.name === frota.driver)
    return motorista ? motorista : ''
  }
  const _getSelectedVeiculo = () => {
    const veiculo = veiculos.find(v => v.vehicle_badge === frota.vehicle_badge)
    return veiculo ? veiculo : ''
  }
  const _getHorarioSaida = () => {
    return frota.departure_time ? frota.departure_time : '__:__'
  }
  const _getIsLated = () => {
    return frota.vehicle_lated ? frota.vehicle_lated : false
  }
  const _getMotivoAtraso = () => {
    const motivoAtraso = motivosAtraso.find(m => m.id === frota.motivo_atraso_id)
    return motivoAtraso ? motivoAtraso : null
  }
  const _getSelectedAjudante = () => {
    if (!frota.driver_assistant_id) return { id: null, name: 'Nenhum' }
    const ajudante = ajudantes.find(a => a.id === frota.driver_assistant_id)
    return ajudante ? ajudante : { id: null, name: 'Nenhum' }
  }

  const _getAjudantesComOpcaoNenhum = () => {
    return [{ id: null, name: 'Nenhum' }, ...ajudantes]
  }

  return (
    <CustomModal
      width="600px"
      header={
        <span>
          Editar - <strong>{frota.vehicle_badge}</strong>
        </span>
      }
      isVisible={isVisible}
      onClose={() => {
        setHorarioSaida('')
        onClose(null)
      }}
    >
      <form className="p-grid" style={{ width: 600 }}>
        <div className="p-grid p-col-12 p-align-center">
          <div className="p-col-4">
            <CustomDropdown
              filter={true}
              label="Veículo"
              optionLabel="vehicle_badge"
              options={veiculos}
              value={selectedVeiculo}
              onChange={value => setSelectedVeiculo(value)}
            />
          </div>
          <div className="p-col-5">
            <CustomDropdownWithFilter
              filter={true}
              label="Motorista"
              optionLabel="name"
              options={motoristas}
              value={selectedMotorista}
              onChange={value => setSelectedMotorista(value)}
            />
          </div>
          <div className="p-col-3" style={{ paddingTop: 0 }}>
            <InputTime
              label="Horário de Saida"
              value={horarioSaida}
              onChange={value => setHorarioSaida(value)}
            />
          </div>
        </div>
        <div className="p-grid p-col-12 p-align-center">
          <div className="p-col-4 p-col-justify-center" style={{ marginTop: 0 }}>
            <CustomCheckbox onChange={value => setIsLated(!isLated)} checked={isLated}>
              Veiculo Atrasado
            </CustomCheckbox>
          </div>
          <div className="p-col-8" style={{ paddingTop: 0, marginTop: 0 }}>
            <CustomDropdown
              disabled={!isLated}
              optionLabel="name"
              options={motivosAtraso}
              value={motivoAtraso}
              label="Motivo de Atraso :*"
              filter={true}
              onChange={value => setMotivoAtraso(value)}
            />
          </div>
        </div>
        <div className="p-grid p-col-12 p-align-center">
          <div className="p-col-6">
            <CustomDropdown
              filter={true}
              label="Ajudante:"
              optionLabel="name"
              options={_getAjudantesComOpcaoNenhum()}
              value={selectedAjudante}
              onChange={value => setSelectedAjudante(value)}
            />
          </div>
        {dataPrevista && (
            <div className="p-col-6">
              <CustomCalendar
                marginTop={0}
                label="Data Prevista de Entrega"
                value={dataPrevista}
                onChange={value => setDataPrevista(value)}
              />
            </div>
        )}
        </div>
        <div className="p-grid p-col-12" style={{ marginTop: 15 }}>
          <div className="p-col-12" style={{ paddingTop: 0 }}>
            <Btn onClick={btnSalvarClicked} isLoading={isBtnLoading}>
              Salvar
            </Btn>
          </div>
        </div>
      </form>
    </CustomModal>
  )
}
export default connect()(ModalEditarElement)
